<template>
    <div class="row">
        <div class="col-12 col-md-4">
            <h5 class="text-orange">
                <span class="mr-2">
                    {{ codigo }}
                </span>

                <b-badge variant="info">
                    {{ statusProjeto}}
                </b-badge>
            </h5>
        </div>
        <div class="col-12 col-md-8">
            <b-button-group size="sm" class="ml-2"  style="float:right">
                <b-dropdown variant="success" right>
                    <template #button-content>
                        <i class="fas fa-file-archive mr-2"></i>
                        Baixar comprovantes
                    </template>

                    <b-dropdown-item @click="baixarComprovantes(false)">Somente custos próprios</b-dropdown-item>
                </b-dropdown>
            </b-button-group>
            <!--<b-button-group size="sm" class="ml-2"  style="float:right">
                <b-dropdown variant="info" right>
                    <template #button-content>
                        <i class="fas fa-file-pdf mr-2"></i>
                        Relatório PDF
                    </template>

                    <b-dropdown-item @click="baixarPDF(false)">Individual </b-dropdown-item>
                    <b-dropdown-item @click="baixarPDF(true)">Consolidado (Todas empresas)</b-dropdown-item>
                </b-dropdown>
                
            </b-button-group>-->
            <b-button @click="baixarExcel(false)"  variant="info" class="ml-2" style="float:right">
                <i class="fas fa-file-excel mr-2"></i>
                Anexo 5
            </b-button>
        </div>
        
        <accordion 
            v-for="accordion in gerarTelas()" 
            :id="accordion.componente" 
            :key="accordion.componente" 
            :title="accordion.titulo"
            :hideTitle="accordion.esconderTitulo && !id" 
            @abriu="abriu(accordion.componente)"

            class="col-12 mt-3"             
        >
            <componentes 
                :componente="accordion.componente"
                :projeto="projeto"
                :ref="accordion.componente"
                @update="buscarProjeto"

                :projeto-editavel="projetoEditavel"

                :chave-permissao="accordion.chavePermissao"
            />
        </accordion>

    </div>
</template>
<script>

import Accordion from '@/components/card/Accordion';
import Componentes from './Componentes'
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import ProjetoGestaoService from '@/common/services/projeto_gestao/projeto_gestao.service';
import {AlertasMixin} from '@/common/mixins/AlertasMixin';
import ComponentesConfig from './componentes.config';
import helpers from '@/common/utils/helpers';
import {Excel} from "@/common/utils/excel";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
export default {
    name: "ProjetoGestaoDetalhamento",
    mixins: [AlertasMixin],
    props: {
        id: {
            type: String,
            default: null
        },
        endpoint: {
            type: String,
            default: null
        },
    },
    components: {
        Accordion,
        Componentes
    },
    data: () => ({
        duracao : 0,
        projeto : null
    }),
    methods: {
        abriu: function(tela) {
            /* eslint-disable */
            try{
                this.$refs[tela][0].montar(tela);
            }catch(e){
                
            }
        },
        gerarTelas : function(){
            if(!this.projeto) return [];
            if(this.ehTelaCooperada)
                return ComponentesConfig.filter(el => el.componente != 'empresas').filter(el => {
                    return this.permissao(el.chavePermissao).r
                });
            return ComponentesConfig.filter(el => {
                return this.permissao(el.chavePermissao).r
            });
        },
        buscarProjeto: function(){
            ProjetoGestaoService.buscarProjetoGestao(this.id).then(response => {
                this.projeto = response.data.data;
            });
        },
        baixarExcel : function(consolidado = false){
            this.$store.dispatch(START_LOADING);
            ProjetoGestaoService.baixarAnexo5(this.id, consolidado).then(res => {
                let xmlString = res.data.data;
                let doc = new DOMParser().parseFromString(xmlString, "text/html");
                const ex = new Excel();
                
                for(let sheet of doc.getElementsByClassName("sheet")){
                    ex.adicionarSheet(sheet, sheet.getAttribute("nome-sheet"));
                }
                ex.baixarExcel("Anexo5.xlsx");
            }).catch(err => {
                console.error(err);
                this.alertaErro("Erro ao gerar excel!")
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        baixarComprovantes : function(incluirComprovantesPagadora){
            ProjetoGestaoService.baixarComprovantes(this.id, incluirComprovantesPagadora).then(res => {
                const blob = new Blob([res.data], { type: 'application/zip' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = `comprovantes.zip`
                link.click();
            })
            .catch(err => {
                if(err.response.status == 400){
                    const blob = new Blob([err.response.data], { type: 'application/json' })
                    const fr = new FileReader();
                    fr.onload = (e) => {                    
                        this.alertaErro(JSON.parse(e.target.result).errors);
                    };
                    fr.readAsText(blob);
                }else   
                    this.alertaErro("Erro ao baixar");
            });
        },
    },
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Projetos de Gestão / GPPDI", to: {name: "projeto-gestao-proponente-lista"}},
            {titulo : "Detalhes"}
        ]);
        
        ProjetoGestaoService.setEndpoint(this.endpoint);

        if(this.id){
            this.buscarProjeto();
        }
    },
    computed : {
        codigo : function(){
            if(!this.projeto) return "";
            return this.ehTelaCooperada ? this.projeto.projetoGestao.codigo : this.projeto.codigo;
        },
        statusProjeto : function(){
            if(!this.projeto) return "";
            return helpers.getEnum(this.ehTelaCooperada ? this.projeto.projetoGestao.status : this.projeto.status).text;
        },
        ehTelaCooperada :function(){
            return this.$route.name != 'projeto-gestao-proponente-detalhamento'
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao'];
        },
        projetoEditavel(){
            if(this.ehAdmin)
                return true;
            return !(this.ehTelaCooperada ? this.projeto.projetoGestao?.projetoFinalizado : this.projeto?.projetoFinalizado);
        },
        ehAdmin() {
            return this.$store.getters["app/ehAdmin"];
        },
    }
}
</script>
<style>
</style>